import { ReactComponent } from "./ic_auto_traffic.svg";

interface Props {
  fill?: string;
  className?: string;
  width?: string;
  height?: string;
}

const AddIcon: React.FC<Props> = (props) => <ReactComponent {...props} />;

export default AddIcon;
